// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { AuthReactConfig, Storage } from "@asgardeo/auth-react";

declare global {
  interface Window {
    config: {
      googleDriveConfig: any;
      asgardeoConfig: {
        baseUrl: string;
        clientID: string;
        signInRedirectURL: string;
        signOutRedirectURL: string;
        scopes: string[];
        resourceServerURLs: string[];
      };
      appConfig: {
        allowedGroups: string[];
        addWorkNoteGroups: string[];
        addEscalationGroups: string[];
        downloadAttachmentGroups: string[];
        usageMetricsGroups: string[];
        sessionTimeoutPrompt: number;
        sessionTimeout: number;
      };
    };
  }
}

export const RESOURCE_SERVER_URLS = window.config?.asgardeoConfig?.resourceServerURLs ?? [];

export const AsgardeoConfig: AuthReactConfig = {
    signInRedirectURL: window.config?.asgardeoConfig?.signInRedirectURL ?? "",
    signOutRedirectURL: window.config?.asgardeoConfig?.signOutRedirectURL ?? "",
    clientID: window.config?.asgardeoConfig?.clientID ?? "",
    baseUrl: window.config?.asgardeoConfig?.baseUrl ?? "",
    scope: window.config?.asgardeoConfig?.scopes ?? [],
    resourceServerURLs: RESOURCE_SERVER_URLS,
    storage: "sessionStorage" as Storage.SessionStorage,
  };

export const ALLOWED_GROUPS = window.config?.appConfig?.allowedGroups ?? [];
export const ADD_WORKNOTE_GROUPS = window.config?.appConfig?.addWorkNoteGroups ?? [];
export const ADD_ESCALATION_GROUPS = window.config?.appConfig?.addEscalationGroups ?? [];
export const DOWNLOAD_ATTACHMENT_GROUPS = window.config?.appConfig?.downloadAttachmentGroups ?? [];
export const USAGE_METRICS_GROUPS = window.config?.appConfig?.usageMetricsGroups ?? [];
export const SESSION_TIMEOUT_PROMPT = window.config?.appConfig?.sessionTimeoutPrompt ?? 20;
export const SESSION_TIMEOUT = window.config?.appConfig?.sessionTimeout ?? 25;
